// src/theme/themes.js
// The portal's colour themes (3.46.0). Each person picks one in Preferences;
// until they do, they get their client's starting theme (a Super Admin sets
// it in Console → Clients & Billing), and Teal if the client has none. The
// colours themselves are in theme/palette.css (scripts/build-palette.js);
// <html data-theme="…"> switches them (theme/useAppearance).
//
// `preview` is what the picker cards draw, in that theme's own colours
// whatever theme is showing now: header band, menu highlight, button and
// table heading, in light and dark. These are the only fixed colours on
// purpose: they show a theme, not the current one.
export const THEMES = [
  {
    id: 'teal', label: 'Teal', blurb: 'Deep teal with fresh green',
    preview: {
      light: { page: '#f4f7f6', card: '#ffffff', band: ['#e0f2f1', '#f1f8e9'], tint: '#e0f2f1', onTint: '#00695c', btn: ['#00695c', '#00796b', '#2e7d32'], head: ['#004d40', '#00695c'], text: '#263238', muted: '#546e7a' },
      dark: { page: '#0e1615', card: '#152120', band: ['#193735', '#1d321a'], tint: '#193735', onTint: '#88e6da', btn: ['#00695c', '#00796b', '#2e7d32'], head: ['#004d40', '#00695c'], text: '#e2ecea', muted: '#a9bcb9' },
    },
  },
  {
    id: 'ocean', label: 'Ocean', blurb: 'Navy and bright blue, with a touch of cyan',
    preview: {
      light: { page: '#f4f5f7', card: '#ffffff', band: ['#e3f2fd', '#e0f7fa'], tint: '#e3f2fd', onTint: '#0d47a1', btn: ['#0d47a1', '#1565c0', '#00838f'], head: ['#0d3c7a', '#0d47a1'], text: '#1f2a37', muted: '#4f6275' },
      dark: { page: '#0b1220', card: '#111b2c', band: ['#16304f', '#0f2b33'], tint: '#16304f', onTint: '#90caf9', btn: ['#0d47a1', '#1565c0', '#00838f'], head: ['#0d3c7a', '#0d47a1'], text: '#e2e9f3', muted: '#9fb1c8' },
    },
  },
  {
    id: 'plum', label: 'Plum', blurb: 'Deep purple with lilac',
    preview: {
      light: { page: '#f7f4f9', card: '#ffffff', band: ['#f3e5f5', '#ede7f6'], tint: '#f3e5f5', onTint: '#6a1b9a', btn: ['#6a1b9a', '#7b1fa2', '#8e24aa'], head: ['#4a148c', '#6a1b9a'], text: '#2a2233', muted: '#5f5370' },
      dark: { page: '#120d17', card: '#1a1321', band: ['#311735', '#24183a'], tint: '#311735', onTint: '#e1bee7', btn: ['#6a1b9a', '#7b1fa2', '#8e24aa'], head: ['#4a148c', '#6a1b9a'], text: '#ece3f2', muted: '#b5a6c3' },
    },
  },
];
export const THEME_IDS = THEMES.map(t => t.id);
export const themeLabel = id => THEMES.find(t => t.id === id)?.label || 'Teal';

// The theme someone sees: their own pick, else their client's, else Teal
export function effectiveTheme(pick, clientTheme) {
  if (THEME_IDS.includes(pick)) return pick;
  if (THEME_IDS.includes(clientTheme)) return clientTheme;
  return 'teal';
}

// Light or dark the same way (3.47.0): their own pick, else their client's
// starting mode, else Auto (same as the computer)
export const MODE_IDS = ['auto', 'light', 'dark'];
export function effectiveMode(pick, clientMode) {
  if (MODE_IDS.includes(pick)) return pick;
  if (MODE_IDS.includes(clientMode)) return clientMode;
  return 'auto';
}
